import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './Footer.css';

const logoUrl = 'https://media-manager-c.questera.ai/greta-media/46a9e1323b5c997de8c3ebac6eb3f9d74ccd00e463a5744676fe05afae233bf74d2b422fbe3649d2b4b7a9fc91fa3904/images/aW1hZ2UvcG5n/d24c30f169df6e3309a305351e2bf9f6.png';
const contactEmail = 'inquiries@profityoglobal.com';

const exploreLinks = [
  ['About Us', '/about'],
  ['Our Ecosystem', '/ecosystem'],
  ['Ventures', '/ventures'],
  ['Partnerships', '/partnerships'],
  ['Innovation', '/innovation']
];

function FooterLinkGroup() {
  return (
    <nav className="fp-footer-links" aria-label="Explore">
      <h3>Explore</h3>
      {exploreLinks.map(([label, path]) => (
        <Link key={path} to={path}>
          {label}
          <SafeIcon icon={FiIcons.FiArrowUpRight} />
        </Link>
      ))}
    </nav>
  );
}

function FooterContact() {
  return (
    <div className="fp-footer-contact">
      <h3>Contact</h3>
      <p>For inquiries and opportunities, reach out to our team.</p>
      <a className="fp-footer-email" href={`mailto:${contactEmail}`}>
        <span className="fp-footer-email-icon">
          <SafeIcon icon={FiIcons.FiMail} />
        </span>
        {contactEmail}
        <SafeIcon icon={FiIcons.FiArrowUpRight} />
      </a>
      <div className="fp-footer-socials">
        <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="ProfitYo Global on LinkedIn">
          <SafeIcon icon={FiIcons.FiLinkedin} />
        </a>
        <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="ProfitYo Global on Instagram">
          <SafeIcon icon={FiIcons.FiInstagram} />
        </a>
      </div>
    </div>
  );
}

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="fp-footer">
      <div className="fp-footer-topline" />
      <div className="container">
        <div className="fp-footer-callout">
          <div>
            <span className="fp-footer-eyebrow">ProfitYo Global System™</span>
            <h2>A broader vision.<br /><em>Built for what comes next.</em></h2>
          </div>
          <Link to="/contact" className="fp-footer-cta">
            Start a conversation
            <SafeIcon icon={FiIcons.FiArrowUpRight} />
          </Link>
        </div>

        <div className="fp-footer-main">
          <div className="fp-footer-brand">
            <Link to="/" className="fp-footer-logo" aria-label="ProfitYo Global home">
              <img src={logoUrl} alt="ProfitYo Global" />
            </Link>
            <p>
              ProfitYo Global System™ is a privately owned group of companies focused on building
              businesses, systems, and growth opportunities. References to affiliated entities,
              strategic partnerships, ventures, or third-party organizations are for informational
              purposes only and do not imply endorsement, sponsorship, or ownership unless expressly stated.
            </p>
          </div>
          <FooterLinkGroup />
          <FooterContact />
        </div>

        <div className="fp-footer-bottom">
          <span>© {currentYear} ProfitYo Global System. All rights reserved.</span>
          <div className="fp-footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
          </div>
          <span className="fp-footer-signoff">Building businesses · Creating systems · Expanding possibilities</span>
        </div>
      </div>
    </footer>
  );
}